const styles = {
  "indicator-icon": "_indicator-icon_147l5_17"
};
export {
  styles as default
};
//# sourceMappingURL=IndicatorIcon.module.css.js.map
